var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useSortBy, useRowSelect, useGroupBy, useExpanded, useColumnOrder, useBlockLayout, useGlobalFilter, usePagination, } from "react-table";
export var tableHooks = [
    useGlobalFilter,
    useColumnOrder,
    useGroupBy,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
];
export var blockTableHooks = __spreadArray(__spreadArray([], tableHooks, true), [useBlockLayout], false);
